import React      from 'react';
import classnames from 'classnames';

import UploadBomButton from './UploadBomButton';
import Info            from './Info';
import HiddenInput     from 'pu-react/components/base/HiddenInput';

export default (props) => {
  const classSection = classnames('pcb-parts-info', { 'd-none': props.showSummary });
  const onChange = props.onChangeParameter;
  const groupName = `items[${props.itemId}][parameters]`;
  const bom_file_name = props.parameters.bom_file;

  const { errors } = props

  return (
    <div className={classSection}>
      <div className="upload-bom">
        <div className="fw-bold">
          Upload BOM
        </div>
        <UploadBomButton
          onUploadBomFile={props.onUploadBomFile}
          bom_file_name={bom_file_name}
          loading={props.loading}
          error={errors.bom_file} />
        <HiddenInput
          name="part_number"
          groupName={groupName}
          value={props.parameters.part_number || ''}
          onChange={e => onChange('part_number', e.target.value)} />
        <HiddenInput
          name="revision"
          groupName={groupName}
          value={props.parameters.revision || ''}
          onChange={e => onChange('revision', e.target.value)} />
        <HiddenInput
          name="bom_file"
          groupName={groupName}
          value={props.parameters.bom_file || ''} />
        <HiddenInput
          name="quantity"
          groupName={`items[${props.itemId}]`}
          value={props.selectedQuantity || ''} />
        <HiddenInput
          name="price"
          groupName={`items[${props.itemId}]`}
          value={props.price} />
        <HiddenInput
          name="variant_id"
          groupName={`items[${props.itemId}]`}
          value={props.itemId} />
        <HiddenInput
          name="bom_quote_number"
          groupName={groupName}
          value={props.bomQuoteNumber || ''} />
        <HiddenInput
          name="item_selected"
          groupName={groupName}
          value={props.itemSelected} />
        <HiddenInput
          name="row_selected"
          groupName={groupName}
          value={props.parameters.row_selected} />
        <HiddenInput
          name="column_selected"
          groupName={groupName}
          value={props.parameters.column_selected} />
      </div>
      <hr />
      <Info />
    </div>
  );
};
